




import { Vue, Component, Prop } from "vue-property-decorator";

import { Validatable } from "@/core/models";
import { DefaultLocale } from "@/core/services";

@Component
export default class ValidationMessage extends Vue {
  @Prop() model: Validatable;
  @Prop() prop: string;

  get validationMessage() {
    if (!this.prop || !this.model || !this.model.modelState) {
      return "";
    }

    const messages = this.model.modelState[this.prop];

    if (!messages || messages.length === 0) {
      return "";
    }

    if(!messages[0]) {
      return "";
    }

    const key = `validation.${messages[0].toString()}`;

    if(this.$te(key)) {
      return String(this.$t(key));
    }

    if(this.$te(key, DefaultLocale)) {
      return String(this.$t(key, DefaultLocale));
    }
    
    return messages[0];
  }
}
